var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDominosSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.876,
    height: 44.894,
    viewBox: "0 0 44.876 44.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DP",
    transform: "translate(-6.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20215",
    "data-name": "Grupo 20215",
    transform: "translate(6.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27596",
    "data-name": "Trazado 27596",
    d: "M46.465,69.74a.8.8,0,0,1-.1.391.731.731,0,0,1-.281.281.8.8,0,0,1-.391.1.756.756,0,0,1-.385-.1.73.73,0,0,1-.281-.281.8.8,0,0,1-.1-.391.756.756,0,0,1,.1-.385.73.73,0,0,1,.281-.281.773.773,0,0,1,.385-.1.814.814,0,0,1,.391.1.73.73,0,0,1,.281.281A.791.791,0,0,1,46.465,69.74Zm-.153,0a.626.626,0,1,0-.183.44A.6.6,0,0,0,46.312,69.74Zm-.977-.415h.373a.323.323,0,0,1,.226.061.213.213,0,0,1,.073.171.219.219,0,0,1-.055.147.3.3,0,0,1-.171.086.219.219,0,0,1,.067.037.6.6,0,0,1,.067.086s.049.086.134.238h-.244a2.042,2.042,0,0,0-.159-.281.115.115,0,0,0-.079-.049h-.024v.324h-.208v-.831Zm.208.354h.092a.218.218,0,0,0,.128-.031.092.092,0,0,0,0-.147.2.2,0,0,0-.122-.031h-.1v.208Z",
    transform: "translate(-25.612 -26.849)",
    fill: "#006492"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20214",
    "data-name": "Grupo 20214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20213",
    "data-name": "Grupo 20213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27597",
    "data-name": "Trazado 27597",
    d: "M26.96,43.21a3.524,3.524,0,1,0,2.5,1.032A3.518,3.518,0,0,0,26.96,43.21Z",
    transform: "translate(-17.246 -16.821)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27598",
    "data-name": "Trazado 27598",
    d: "M43.93,50.5a3.534,3.534,0,0,0,3.536-3.53A3.537,3.537,0,1,0,43.93,50.5Z",
    transform: "translate(-23.853 -16.906)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27599",
    "data-name": "Trazado 27599",
    d: "M54.339,2.44a1.5,1.5,0,0,0-2.125,0L41.99,12.663l-2.98,2.98L53.331,29.965l1.215-1.215L66.535,16.761a1.511,1.511,0,0,0,0-2.131Z",
    transform: "translate(-23.311 -0.779)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27600",
    "data-name": "Trazado 27600",
    d: "M57.39,12.99,45.194.8a2.713,2.713,0,0,0-3.848,0L31.123,11.024,14.1,28.044a2.728,2.728,0,0,0,0,3.854l12.19,12.2a2.713,2.713,0,0,0,3.848,0L45.4,28.838,57.384,16.85a2.728,2.728,0,0,0,0-3.854Z",
    transform: "translate(-13.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27601",
    "data-name": "Trazado 27601",
    d: "M66.543,14.64,54.347,2.45a1.511,1.511,0,0,0-2.131,0L39.03,15.635,53.351,29.957,66.537,16.771a1.511,1.511,0,0,0,0-2.131ZM55.819,18.164a3.524,3.524,0,1,1,1.038-2.5A3.518,3.518,0,0,1,55.819,18.164Z",
    transform: "translate(-23.319 -0.782)",
    fill: "#e31938"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27602",
    "data-name": "Trazado 27602",
    d: "M15.73,38.933a1.511,1.511,0,0,0,0,2.131l12.2,12.2a1.5,1.5,0,0,0,2.125,0L43.23,40.081,28.909,25.76,15.73,38.939Zm10.559,3.512a3.539,3.539,0,1,1,1.032-2.5A3.544,3.544,0,0,1,26.289,42.445ZM31.657,37.6a3.539,3.539,0,1,1-1.032,2.5A3.525,3.525,0,0,1,31.657,37.6Z",
    transform: "translate(-14.078 -10.028)",
    fill: "#006492"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27603",
    "data-name": "Trazado 27603",
    d: "M26.96,43.24a3.524,3.524,0,1,0,2.5,1.032A3.518,3.518,0,0,0,26.96,43.24Z",
    transform: "translate(-17.246 -16.832)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27604",
    "data-name": "Trazado 27604",
    d: "M43.93,50.536a3.534,3.534,0,0,0,3.536-3.53,3.537,3.537,0,1,0-3.536,3.53Z",
    transform: "translate(-23.853 -16.922)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27605",
    "data-name": "Trazado 27605",
    d: "M54.339,2.47a1.5,1.5,0,0,0-2.125,0L41.99,12.693l-2.98,2.98L53.331,29.995l1.215-1.215L66.535,16.791a1.511,1.511,0,0,0,0-2.131Z",
    transform: "translate(-23.311 -0.79)",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominosSingle);
export default __webpack_public_path__ + "static/media/dominos-single.27c3f789c7269a7d3c67d8e056782bf2.svg";
export { ForwardRef as ReactComponent };